import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';
import styled from 'styled-components';

import { MoreCaseStudies } from '../../../../components'

import { meta } from '../../index.js'

export default class goget extends Component {
	render () {
		return (
			<React.Fragment>
				<Helmet
					title={meta.title.replace('blueshyft', 'GoGet')}
					meta={[
						{ name: 'description', content: meta.description },
						{ property: 'og:title', content: meta.title },
						{ property: 'og:url', content: meta.url },
						{ property: 'og:site_name', content: 'Blueshyft' },
						{ property: 'og:type', content: 'website' },
						{ property: 'og:image', content: meta.url + meta.image },
						{ property: 'og:description', content: meta.description },
						{ property: 'twitter:card', content: 'summary_large_image' },
						{ property: 'twitter:site', content: '@Blueshyft' },
						{ property: 'twitter:title', content: meta.title },
						{ property: 'twitter:description', content: meta.description },
						{ property: 'twitter:image', content: meta.url + meta.image },
					]}
				/>
				
				<section className="case-study"> 

				    <div className="container">

				        <div className="title">

				            <a href="https://goget.com.au" target="_blank"><img src="/images/new/logos/goget-dot-com.svg"/></a>
				            <h3>The leaders in car sharing</h3>
				            <p>GoGet has been growing rapidly and now accounts more than 20% of all City of Sydney drivers and 10% of City of Melbourne households as members. As more and more people sign up for a service that is meant to match the convenience of the private car, the consumer expectation is for immediate vehicle access. The only problem? Lacking a bricks-and-mortar presence, GoGet faced the dilemma encountered by many online and app-based services: getting new members through the on-boarding process and into their vehicles immediately.</p>

				        </div>

				        <div className="block">

				            <h4>Realising inefficiencies</h4>
				            <p>GoGet customers were waiting up to 5 business days to receive an activation pack in the mail before they were able to use a GoGet vehicle. A major pain point for customers, GoGet saw value in a nationwide network, turning on instant onboarding for prospects.</p>

						</div>

							<div className="block">

							<h4>Joining the dots</h4>
				            <p>While GoGet’s focus had been directed towards online efficiencies, the stumbling block of physical, real-world inefficiencies had been largely overlooked. GoGet streamlined their onboarding process via the blueshyft network, enabling customers to collect an activation pack from any blueshyft store instead of waiting days for a pack to arrive in the mail. For GoGet, this meant:</p>

				            <div className="features">

				                <div className="feature">
				                    <img src="/images/new/icons/page-blue.svg"/>
				                    <p>In-store customer acquisitions</p>
				                </div>
				                <div className="feature">
				                    <img src="/images/new/icons/cog-blue.svg"/>
				                    <p>Streamlined account activations</p>
				                </div>
				                <div className="feature">
				                    <img src="/images/new/icons/id-blue.svg"/>
				                    <p>Easy ID verification</p>
				                </div>
				                <div className="feature">
				                    <img src="/images/new/icons/map-blue.svg"/>
				                    <p>A national starter pack distribution channel</p>
				                </div>

				            </div>
				    
				        </div>

				        <div className="block">

				            <h4>A streamlined solution</h4>
				            <p>GoGet’s partnership with blueshyft addressed the company’s on-boarding processes and physical visibility:</p>
				            <p>•  A new GoGet member can now visit their closest participating agent to activate their account, verify their identity, and drive away in a share-care that day:</p>
				            <p>•  GoGet is able to cut their wait time for a posted starter pack to real-time activation, which it estimated resulted in a third of all acquisitions going unrealised</p>
				            <p>•  blueshyft’s network instantly gives GoGet 1,500+ brick-and-mortar storefronts to sign-up and engage new members</p>

				        </div>

				        <div className="highlight">

				            <p>Since launch, GoGet have dramatically reduced activation waiting periods, and have, in turn, seen an impressive increase in sign-ups and customer satisfaction. Meanwhile, blueshyft’s 1,500+ physical locations have increased the accessibility of Goget’s services, extending their physical reach to every state across the country.</p>
				    
				        </div>

				    </div>


				</section>

				<MoreCaseStudies cases={['lb', 'news', 'sk']} />

			</React.Fragment>
		);
	}
};


// WEBPACK FOOTER //
// ./client/scenes/Clients/scenes/goget/index.js